<template>
  <NuxtLayout>
    <!--
      `page-key` is the path only, so every path gets a fresh instance and the top-level
      `await useAsyncData(...)` in index.vue/[...slug].vue re-runs on client-side navigation. Never
      add the query to it: the CMS entry is resolved from the path, so re-keying on a query change
      rebuilds the page for nothing on every filter click and keystroke, and a page fetch that loses
      that race reaches the visitor as a 404. Query changes belong in the stores, through the route
      watchers in the template components.
    -->
    <NuxtPage :page-key="(route) => route.path" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

// Load the CMS translation overrides for the active locale and merge them on top of the static messages.
const i18n = useI18n()
const translationStore = useTranslationStore()

// Watched on the locale: the language switch navigates with NuxtLink, so this setup does not run again
// on a client-side switch and the new locale would otherwise keep the static messages only.
await useAsyncData('translations', async () => await translationStore.load({ locale: i18n.locale.value }), {
  watch: [i18n.locale],
})

// Merge from the store rather than from the fetch result: `load` sets the locale and its messages in one
// go, so a locale's overrides are never merged into the other locale while a switch is still in flight.
watchEffect(() => i18n.mergeLocaleMessage(translationStore.locale, translationStore.translations))
</script>
